import React from 'react';
import { compose, withProps } from 'recompose';
import { Page } from 'components/core/Page';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withExperiment } from '@sparefoot/react-core/decorators';
import { withPageViewTracking } from 'components/core/library/tracking-utils';
import { withSearchHandler } from 'decorators';
import { WhySSDC } from 'components/plp/WhySSDC/WhySSDC';
import { TrustPilotReviewSection } from 'components/landing/TrustPilotReviewSectionV2';
import { PAGE_TYPES } from '@sparefoot/tracking-events';

import { getCanonicalStorageType, PPC_TYPE_STORAGE } from 'config/constants';
import { toTitleCase } from 'utils/formatting';

import PSPLayout from 'components/psp/PSPLayout/PSPLayout';

import HowItWorksSection from 'components/plp/HowItWorks/HowItWorksSection';
import { PLPBottom } from 'components/plp/PLPBottom/PLPBottom';
import { PLPFooter } from 'components/plp/PLPFooter/PLPFooter';
import './PaidLandingPage.scss';

const enhance = compose(
	connect((state) => {
		return {
			storageType: state.pages.storageType,
			metaTitle: state?.pages?.meta?.title,
			metaDescription: state?.pages?.meta?.description,
		};
	}),
	withProps(({ storageType }) => {
		const canonicalType = getCanonicalStorageType(storageType);
		// Default to storage search params
		let additionalSearchParams = {};
		let typeProp = 'storage';

		if (canonicalType !== PPC_TYPE_STORAGE) {
			// vehicle landing page — instruct withSearchHandler to include vehicle params
			additionalSearchParams = {
				type: 'vehicle',
				vehicle: canonicalType,
			};
			typeProp = 'vehicle';
		}

		return {
			pageType: toTitleCase(storageType), // storageType is validated in getPaidLandingPage action
			additionalSearchParams,
			type: typeProp,
		};
	}),
	withSearchHandler,
	withExperiment('sf_15731_plp_refactor_ssdc'),
	withPageViewTracking(PAGE_TYPES.PPC),
);

export function PaidLandingPage({
	pageType,
	metaTitle,
	metaDescription,
	handleSearch,
}) {
	return (
		<Page
			title={metaTitle}
			description={metaDescription}
			marketingPage
		>
			<PSPLayout
				storageType={pageType}
				handleSearch={handleSearch}
			/>
			<HowItWorksSection />
			<TrustPilotReviewSection />
			<WhySSDC />
			<PLPBottom
				storageType={pageType}
				handleSearch={handleSearch}
			/>
			<PLPFooter />
		</Page>
	);
}

PaidLandingPage.propTypes = {
	pageType: PropTypes.string.isRequired,
	metaTitle: PropTypes.string,
	metaDescription: PropTypes.string,
	handleSearch: PropTypes.func,
};

export default enhance(PaidLandingPage);
